var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "archive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients",
    transform: "translate(-1307.000000, -414.000000)",
    fill: "#03053D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(1307.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,7.00000215 L0,7.00000215 L0,1.00300234 C0,0.449004342 0.455,2.15388175e-06 0.992,2.15388175e-06 L19.008,2.15388175e-06 C19.1393,-0.000271657853 19.2693,0.0255633421 19.3905,0.0760083421 C19.5117,0.126453342 19.6217,0.200499342 19.714,0.293837342 C19.8063,0.387175342 19.8791,0.497941342 19.9282,0.619692342 C19.9773,0.741442342 20.0017,0.871732342 20.0000831,1.00300234 L20.0000831,7.00000215 L19,7.00000215 L19,17.0010023 C19.0004,17.1318023 18.975,17.2614023 18.9253,17.3824023 C18.8756,17.5034023 18.8026,17.6134023 18.7104,17.7062023 C18.6182,17.7989023 18.5086,17.8726023 18.3879,17.9230023 C18.2672,17.9735023 18.1378,17.9996023 18.007,18.0000022 L1.993,18.0000022 C1.8622,17.9996023 1.73276,17.9735023 1.61207,17.9230023 C1.49139,17.8726023 1.38181,17.7989023 1.2896,17.7062023 C1.19739,17.6134023 1.12436,17.5034023 1.07467,17.3824023 C1.02498,17.2614023 0.999605,17.1318023 1,17.0010023 L1,7.00000215 Z M17,7.00000234 L3,7.00000234 L3,16.0000023 L17,16.0000023 L17,7.00000234 Z M2,2.00000234 L2,5.00000234 L18,5.00000234 L18,2.00000234 L2,2.00000234 Z M7,9.00000234 L13,9.00000234 L13,11.0000023 L7,11.0000023 L7,9.00000234 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon_archive.6b8f231abe06681b793dc525751bf968.svg";
export { ForwardRef as ReactComponent };